import React from "react"

const PageText = ({ children }) => <p className="page text">{children}</p>

export default PageText



// WEBPACK FOOTER //
// ./src/medium/PageText.js